export default __webpack_public_path__ + "static/media/OKTIO_template_items.eedb16ae.csv";